import { render, staticRenderFns } from "./AddTaxPaymentModal.vue?vue&type=template&id=6bee0f01&"
import script from "./AddTaxPaymentModal.vue?vue&type=script&lang=ts&"
export * from "./AddTaxPaymentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports